import { render, staticRenderFns } from "./SubCatDetailModal.vue?vue&type=template&id=3e326592"
import script from "./SubCatDetailModal.vue?vue&type=script&lang=js"
export * from "./SubCatDetailModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports